import * as types from './actionTypes';

export function clearErrorMessage() {
    return (dispatch) => dispatch({ type: types.CLEAR_RESPONSE_ERROR});
}